import React from "react";
import { Icon } from "@iconify/react";
import "./SocialMediaAsidePanel.scss"

const SocialMediaAsidePanel = () => {
  return (
    <div className="fixed-icons">
      <a
        className="linkedin"
        href="https://www.linkedin.com/company/sigmacem-international/"
        target="_blank"
        rel="noreferrer"
        title="Check our LinkedIn"
      >
        <Icon
          icon="akar-icons:linkedin-v2-fill"
          color="white"
          width="32"
          height="32"
        />
      </a>
      <a
        className="instagram"
        href="https://www.instagram.com/sigmacem/"
        target="_blank"
        rel="noreferrer"
        title="OCheck our Instagram"
      >
        <Icon icon="fe:instagram" color="white" width="32" height="32" />
      </a>

      <a
        className="youtube"
        href="https://www.youtube.com/channel/UCSMEMAAYOODt2OIjEGaTYWg"
        target="_blank"
        rel="noreferrer"
        title="Check our YouTube"
      >
        <Icon
          icon="ant-design:youtube-outlined"
          color="white"
          width="32"
          height="32"
        />
      </a>
    </div>
  );
}

export default SocialMediaAsidePanel;
